module.exports = __webpack_public_path__ + "img/BGBody.f1005cd1.jpg";